import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./errorMessage.style";
export var ErrorMessage = function(param) {
    var error = param.error;
    if (!error) return null;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(S.StyledErrorMessage, {
            children: error
        })
    });
};
